import React ,{useEffect, useState ,useContext} from "react";
import './requestAttendance.css'
import strings from "../../utils/property-file/requestAttendance.json"
import RequestPopUp from "./requestPopUp";
import api from "../../services/api";
import moment from "moment";
import { toast } from "react-toastify";
import SpinnerButton from "../button/spinnerButton";
import { AttendanceRequestContext } from "../requestContext";
import DisputeModal from "./disputeModal";

export default function RequestAttendance() {
  const [requestModal, setRequestModal] = useState(false);
  const [disputeModal , setDisputeModal] = useState(false);
  const [requestDetails ,setRequestDetails] = useState([]);
  const [disputeDetails , setDisputeDetails] = useState([]);
  const [fetchingData , setFetchingData] = useState(false);
  const [refreshList ,setRefreshList] = useState("refresh-request-attendance")
  const [requestDetailsIndividual , setRequestDetailsIndividual] = useState()
  const { setAttendanceRequestCount} = useContext(AttendanceRequestContext);
  const [attendanceRequest , setAttendanceRequest] = useState(true);
  const [raisedDisputes , setRaisedDisputes] = useState([]);

  const fetchAttendanceRequest = async () =>{
    try{
      setFetchingData(true)
        const response = await api.getAttendanceRequest();
        if(response.success && response.data)
        {
          if(response.data)
          {
          const data = JSON.parse(response.data);
          setRequestDetails(data.requests);
          setRefreshList("refresh-request-attendance");
          }
        }
        else{
          setRequestDetails([]);
        }
        fetchRequestCount(); 
        setRefreshList("refresh-request-attendance");
        setFetchingData(false)
    }
    catch(error){
      toast.error(strings.somethingWentLabel ,{toastId : "error06"})
      setRefreshList("refresh-request-attendance");
    }
  }

  const fetchRaisedDisputes = async () =>{
    try{
      setFetchingData(true)
        const response = await api.getRaiseDispute();
       if(response && response.data){
        const data = JSON.parse(response.data);
        if(response.success) {
          setRaisedDisputes(data.body ? data.body : []);
          setRefreshList("refresh-request-attendance");
        }
        else {
          setRaisedDisputes([]);
        }
        setRefreshList("refresh-request-attendance"); 
         setFetchingData(false);
       }
    }
    catch(error){
      setRaisedDisputes([]);
      setRefreshList("refresh-request-attendance");
      toast.error(strings.somethingWentLabel ,{toastId : "error06"})
    }
  }

  const fetchRequestCount = async () =>{
    try{
      const response = await api.getAttendanceRequestCount();
      if(response.success && response.data){
        const data = JSON.parse(response.data);
        setAttendanceRequestCount(data.requestCount.count);
      }
      else
      {
        setAttendanceRequestCount(null);
      }
    }
    catch(error){
      toast.error(strings.somethingWentWrong)
    }
  }

  useEffect(()=>{
    fetchAttendanceRequest();
    fetchRaisedDisputes();
  },[])

    return(
            <div className="request-attendance-main-container">
            <div className="search-request-attendance">
            <div className={refreshList} title="Refresh-button">
                <i className="ri-restart-line" onClick={(()=>{
                  setRefreshList("refresh-request-attendance-active");
                  fetchAttendanceRequest();
                  fetchRaisedDisputes();
                })}></i>
                </div>
            </div>
            <div className="request-attendance-sub-container">
                <div className={attendanceRequest ? "request-attendance-sheet-heading-active" : "request-attendance-sheet-heading"} onClick={(()=>{setAttendanceRequest(true)})}>
                    {strings.allRequestLabel}
                </div>
                <div className={attendanceRequest ? "request-attendance-sheet-heading" : "request-attendance-sheet-heading-active"} onClick={(()=>{setAttendanceRequest(false)})}>
                  {strings.disputeLabel}
                </div>
            </div>
           {attendanceRequest ?  <div className="request-attendance-table-main-container">
            <div className="request-table-layout mt-3 mx-auto table-data  employee-attendance">
              <table className="table attendance-request-table">
                <thead className="requests-status-header">
                  <tr>
                    <th scope="col">{strings.srNumberLabel}.</th>
                    <th scope="col">{strings.requesterNameLabel}</th>
                    <th scope="col">{strings.checkOutLabel}</th>
                    <th scope="col">{strings.checkOutDateLabel}</th>
                    <th scope="col">{strings.timeOfRequestLabel}</th>
                  </tr>
                </thead>
{fetchingData ? <div className="fetching-data-attendance-request"><SpinnerButton/> </div> :
<tbody className="employee-status-body">
      {requestDetails.length > 0 ? (
     <>
      {requestDetails.map((request, index) => (
        <tr
          className="requested-list"
          key={index}
          onClick={() => {
            setRequestDetailsIndividual(requestDetails[index])
            setRequestModal(true);
          }}
        >
          <td>{index + 1}.</td>
          <td>{request.userName.name}</td>
          <td>{moment(request.checkoutTime).format("HH:mm")}</td>
          <td>{moment(request.checkoutTime).format("DD-MM-YYYY")}</td>
          <td>{moment(request.createdDate).format("DD-MM-YYYY HH:mm")}</td>
        </tr>
      ))}
    </>
  ) : (
    <tr>
      <td colSpan={5}>{strings.noRecordExist}</td>
    </tr>
  )}
</tbody>
}
              </table>
            </div>
            {requestModal && <div className="request-pop-up-container">
            <RequestPopUp
              show={requestModal}
              onHide={() => setRequestModal(false)}
              requestData={requestDetailsIndividual}
              fetchRequest={fetchAttendanceRequest}
            />
            </div>} 
            </div> :
            <div className="request-attendance-table-main-container">
            <div className="request-table-layout mt-3 mx-auto table-data  employee-attendance">
              <table className="table attendance-request-table">
                <thead className="requests-status-header">
                  <tr>
                    <th scope="col">{strings.srNumberLabel}.</th>
                    <th scope="col">{strings.requesterNameLabel}</th>
                    <th scope="col">{strings.checkInLabel}</th>
                    <th scope="col">{strings.typeLabel}</th>
                    <th scope="col">{strings.checkOut}</th>
                    <th scope="col">{strings.timeOfRequestLabel}</th>
                  </tr>
                </thead>
{fetchingData ? <div className="fetching-data-attendance-request"><SpinnerButton/> </div> :
<tbody className="employee-status-body">
      {raisedDisputes.length > 0 ? (
     <>
      {raisedDisputes.map((request, index) => (
        <tr
          className="requested-list"
          key={index}
          onClick={() => {
            setDisputeDetails(raisedDisputes[index]);
            setDisputeModal(true);
          }}
        >
          <td>{index + 1}.</td>
          <td>{request.username}</td>
          <td>{moment(request.actualInTime).format("HH:mm")}</td>
          <td>{request.type ? (request.type===strings.both ? strings.bothLabels: request.type) : null}</td>
          <td>{request.actualOutTime!=null ? moment(request.actualOutTime).format("HH:mm") : strings.naLabel}</td>
          <td>{moment(request.createdDate).format("DD-MM-YYYY HH:mm")}</td>
        </tr>
      ))}
    </>
  ) : (
    <tr>
      <td colSpan={6}>{strings.noRecordExist}</td>
    </tr>
  )}
</tbody>
}
              </table>
            </div>
            {disputeModal && <div className="request-pop-up-container">
            <DisputeModal
              show={disputeModal}
              onHide={() => setDisputeModal(false)}
              requestData={disputeDetails}
              dataFetch={fetchRaisedDisputes}
            />
            </div>} 
            </div>
            }
            </div>
    )
}